import React, { useState } from "react";

import { NameEntity } from "../../helpers/NameEntity";
import { UsersStorageModel } from "../../services/user/UsersStorage";
import FormField from "../form-field/FormField";
import SuggestionBox from "../suggestion-box/SuggestionBox";
import { api } from "../../services/api/ApiService";

interface EditAssignedUserProps {
  assignedUser: NameEntity | null;
  setFieldValue: Function;
  disabled?: boolean;
}

export default function EditAssignedUser(props: EditAssignedUserProps) {
  const { setFieldValue } = props;

  const [usersService] = useState(() => UsersStorageModel.create({}, { api }));

  const clearAssignedUserFieldValue = (text: string) => {
    if (!text)
      setFieldValue("assignedUser", '');
  };

  return (
    <FormField
      id="assigned-user"
      labelKey="EditAssignedUser.label"
      fieldName="assignedUser"
      fieldValue={props.assignedUser ? props.assignedUser.id : null}
      children={() => (
        <SuggestionBox
          defaultSelectedItem={props.assignedUser?.id ? props.assignedUser : undefined}
          onSearchTextChange={(searchText) =>
            usersService.getFilteredUsersExcludingGuest(searchText)
          }
          searchTextChanged={clearAssignedUserFieldValue}
          selectedItemChanged={(user: NameEntity | undefined) =>
            setFieldValue("assignedUser", user ?? null)
          }
          placeholderKey="EditAssignedUser.add"
          noResultsFoundKey="general.users.not-found"
          disabled={props.disabled}
          clearCurrentItem={() => clearAssignedUserFieldValue("")}
        />
      )}
      errorName="assignedUser"
    />
  );
}
